import React, { Component } from 'react';
import AnyModel from "../../models/anymodel";
import  PanelLayout  from "../layout/panel-layout";
import { Link } from 'react-router-dom';
import Select from 'react-select';
import SimpleReactValidator from 'simple-react-validator';
import BFileInput from "../../helpers/bfile-input";
import { Markup } from 'interweave';
import { apiConstants } from "./../../constants/api.constants";
import moment from 'moment-jalaali';
import CountUp from 'react-countup';
import  NewMessageList  from "./../partials/newmessagelist";
import  CertReqByPhysicianInMonth  from "./../partials/certreqbyphysicianinmonth";
import NewCertReqList from "./../partials/newcertreqlist";
import CertReqPlot from "./../partials/certreqplot";
import  DashboardBox  from "./../partials/dashbooardbox";
import { formatNumber,latinToPersian } from "./../../helpers/persian-number/PersianNumber";

function currencyFormatter(value)
{
    return latinToPersian(formatNumber(value));
}

function persianFormatter(value)
{
    return latinToPersian(value);
}

class Dashboard extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           model:new AnyModel(this.refs),
        
        };
      
       

    }

   
    
   
    componentWillReceiveProps(newProps)
    {
        const {model}=newProps;
        if(model)
        {
            this.setState({
                model:model,
            });

            
            
        }

       
    }


    render() { 
        //const {model} = this.props;
        const {model}= this.state;

     
        const {loading,error} = this.props;
    

 
        return ( 

        <PanelLayout title={"داشبورد"}>
            
            <div className="panel-body custom">
                
                <DashboardBox model={model && model}></DashboardBox>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">آمار</div>
                            <div className="panel-body">

                                <div className="row">
                                    <div className="col-md-6">
                                        <CertReqPlot formatter={currencyFormatter}  title={'تعداد گواهی صادر شده در 6 ماه'} categories={model && model.LastSixMonthsNames} data={model && model.LastSixMonthCertReqCount}></CertReqPlot>   
                                    </div>
                                    <div className="col-md-6">
                                    <CertReqPlot formatter={currencyFormatter} title={'میزان دریافتی 6 ماه'} categories={model && model.LastSixMonthsNames} data={model && model.LastSixMonthCertReqPayment}></CertReqPlot>    
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="panel panel-default">
                            <div className="panel-heading">تعداد گواهی صادر شده در ماه جاری</div>
                            <div className="panel-body">
                                <CertReqByPhysicianInMonth list={model && model.PhysicianCertificatesNumberInMonthList}></CertReqByPhysicianInMonth>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">

                        <div className="panel panel-default">
                            <div className="panel-heading">تعداد گواهی صادر شده در روز جاری</div>
                            <div className="panel-body">
                            <CertReqByPhysicianInMonth list={model && model.CertReqInCurrentDay}></CertReqByPhysicianInMonth>
                            </div>
                        </div>

                    </div>
                </div>
 

                <div className="row">
                    <div className="col-md-6">
                        <div className="panel panel-default">
                            <div className="panel-heading">پیام های جدید</div>
                            <div className="panel-body">
                                <NewMessageList list={model && model.NewMessageList}></NewMessageList>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">

                        <div className="panel panel-default">
                            <div className="panel-heading">درخواست پذیرش</div>
                            <div className="panel-body">
                                <NewCertReqList list={model && model.NewCertificationRequestFromOutList}></NewCertReqList>
                            </div>
                        </div>

                    </div>
                </div>
 
               
            </div>

            
                
           
        </PanelLayout>





        );
    }
}

 
export default Dashboard;